const Home = () => {
  return (
    <div>
      <h1>Welcome to Game Hub</h1>
    </div>
  );
};

export default Home; 